import { useState } from 'react'

import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'

const useFieldState = (field: CustomizationField) => {
  const [enabled, setEnabled] = useState<boolean>(field.enabled)
  const [running, setRunning] = useState<boolean>(false)
  const canChangeEnabled = field.editableEnabled && !running
  const toggleEnableLocally = async (
    remoteUpdate: (field: CustomizationField, newEnabled: boolean) => Promise<void>
  ) => {
    const value = !enabled
    setEnabled(value)
    setRunning(true)
    try {
      await remoteUpdate(field, value)
    } catch (error) {
      setEnabled(!value) // Revert state if remote change fails
      throw error
    } finally {
      setRunning(false)
    }
  }

  return {
    field,
    enabled,
    canChangeEnabled,
    toggleEnableLocally,
  }
}

export default useFieldState
